export const styles = () => ({
  contentWrapper: { padding: 25 },
  bluePrimaryBackground: { backgroundColor: '#e5f0ff', padding: 25 },
});
